<template>
  <!-- 这个是支付结果页面 -->
  <div class="pay">
    <div class="pay_nav">
      <div class="pay_nav_url" @click="ret">
        <img class="pay_nav_img" src="@/img/tag_tab_return_1.png" alt="" />
      </div>
      <div class="pay_nav_text">{{ $t("Pay.Result") }}</div>
    </div>
    <div class="pay_centent">
      <div class="pay_url">
        <!-- 付款成功 -->
        <img
          class="pay_url_img"
          v-if="state >= 1"
          src="@/img/tag_pop_ups_1.png"
          alt=""
        />

        <!--  错误状态 -->
        <img
          class="pay_url_img"
          v-else-if="state == -99"
          src="@/img/tag_pop_ups_1.png"
          alt=""
        />
        <!-- 付款失败 -->
        <img class="pay_url_img" v-else src="@/img/tag_pop_error.png" alt="" />
        <img class="pay_shadow" src="@/img/shadow.png" alt="" />
      </div>
      <!-- 付款成功 -->
      <div class="pay_title" v-if="state >= 1">{{ $t("Pay.Successful") }}</div>

      <!-- 错误状态 -->
      <div class="pay_title" v-else-if="state == -99">
        {{ $t("Pay.abnormity") }}
      </div>
      <!-- 付款失败 Pay Failed-->
      <div class="pay_title" v-else>{{ $t("Pay.Failure") }}</div>
      <div
        class="pay_button"
        @touchstart="Playtouchstart()"
        @touchend="Playtouchend()"
        @click="ret"
        :class="bgstate ? 'active' : ''"
      >
        {{ $t("Pay.GO_BACK") }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import configs from "@/config/config.js";
export default {
  name: "",
  data() {
    return {
      bgstate: false,
      // urldata: JSON.parse(localStorage.getItem("urldata")),
      state: configs.GetQueryString("type") || this.$route.query.type
      // coin:this.$route.query.coin  ||null,
      // price:this.$route.query.price ||null,
      // currency:this.$route.query.currency ||null,
      // symbol:this.$route.query.symbol ||null,
      // url:this.$route.query.url
    };
  },
  created() {
    this.state = configs.GetQueryString("type") || this.$route.query.type;
    console.log("获取urldata", this.state);
    // localStorage.setItem("orderid",this.$route.query.orderid)
  },
  watch: {
    $route(to, from) {
      console.log("$route$route$route", to);
      this.state = to.query.type;
    }
  },
  mounted() {},
  methods: {
    Playtouchstart() {
      this.bgstate = true;
      // this.bg_scrollTop = document.querySelector('.diamond').scrollTop;
    },
    Playtouchend() {
      this.bgstate = false;
    },
    // 后退
    ret() {
      this.$router.go(-1);
      // this.$router.push({
      //   	path: '/index',
      //    query: { redirect: to.fullPath }
      // })
    }
  }
};
</script>

<style scoped="scoped">
.pay {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  width: 100%;
  height: 100%;
  background-color: var(--bg);
}
.pay_nav {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 1.44rem;
  position: relative;
}

.pay_nav_url {
  box-sizing: border-box;
  width: 1.2rem;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  padding-left: 0.54rem;
  display: flex;
  align-items: center;
}
.pay_nav_img {
  width: 0.72rem;
  height: 0.72rem;
}

.pay_nav_text {
  font-size: 0.54rem;
  color: var(--payStatusTitle);
}
.pay_url {
  margin: 1.3rem auto 0;
  width: 1.8rem;
  height: 1.8rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.pay_url_img {
  width: 1.8rem;
  height: 1.8rem;
}
.pay_shadow {
  margin-top: 0.15rem;
  width: 0.54rem;
  height: 0.08rem;
}
.pay_title {
  margin-top: 0.43rem;
  font-size: 0.54rem;
  text-align: center;
  color: var(--payStatusText);
  margin-bottom: 1.57rem;
}
.pay_box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 auto 0.24rem;
  width: 8.64rem;
  height: 0.9rem;
  background-color: rgba(48, 90, 98, 0.1);
  padding: 0 0.43rem;
}
.pay_box_text {
  font-size: 0.36rem;
  color: #202020;
  opacity: 0.5;
}
.pay_box_sum {
  font-size: 0.36rem;
  color: #202020;
}
.pay_text {
  margin: 1.12rem auto 0;
  width: 8.57rem;
  font-size: 0.36rem;
  color: #202020;
  opacity: 0.5;
}
.pay_button {
  margin: 1.46rem auto 0;
  width: 8.64rem;
  height: 1.2rem;
  background-color: var(--payStatusBtnBackground);
  box-shadow: inset 0px -0.1rem 0px 0px rgba(0, 0, 0, 0.05);
  border: solid 0.02rem rgba(0, 0, 0, 0.15);
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0.6rem;
  font-size: 0.48rem;
  color: var(--payStatusBtnColor);
}
.active {
  background-color: #e5e5e5;
}
</style>



// WEBPACK FOOTER //
// src/components/pay_details.vue